var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Tooltip, TooltipTrigger, View } from '@adobe/react-spectrum';
import { ActionButton } from '@react-spectrum/button';
const TriggerFakeButtonStyles = {
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: '100%',
    height: '100%',
    opacity: 0,
};
export const StaticTooltipTrigger = (props) => {
    const { tooltip, onPress } = props, triggerProps = __rest(props, ["tooltip", "onPress"]);
    return (React.createElement(TooltipTrigger, Object.assign({ delay: 0, isDisabled: false }, triggerProps),
        React.createElement(ActionButton, { excludeFromTabOrder: true, UNSAFE_style: TriggerFakeButtonStyles, onPress: onPress }),
        React.createElement(Tooltip, null, tooltip)));
};
export const DisabledActionButton = (props) => {
    const { label, tooltip } = props, triggerProps = __rest(props, ["label", "tooltip"]);
    return (React.createElement(View, { UNSAFE_style: { position: 'relative' } },
        React.createElement(ActionButton, { "data-test-id": "header-publish", isDisabled: true, isQuiet: true }, label),
        React.createElement(StaticTooltipTrigger, Object.assign({ tooltip: tooltip }, triggerProps))));
};
